import moment, { MomentInput } from 'moment';

export const getYear = (date?: MomentInput, format?: string): number => {
  return parseInt(moment(date, format).format('YYYY'));
};

export const getMonth = (date?: MomentInput, format?: string): number => {
  return parseInt(moment(date, format).format('M'));
};

export const getDay = (date?: MomentInput, format?: string): number => {
  return parseInt(moment(date, format).format('D'));
};

export const formatUpdateTime = (time: string) => {
  const now = moment();
  const updateTime = moment(time);
  if (updateTime.isSame(now, 'day')) {
    return updateTime.format('HH:mm');
  } else if (updateTime.isSame(now, 'year')) {
    return updateTime.format('MM.DD HH:mm');
  }
  return updateTime.format('YYYY.MM.DD');
};
